// extracted by css-extract-rspack-plugin
export default {"cls1":"ModalError-cls1_CN0","cls2":"ModalError-cls2_uia ModalError-cls1_CN0"};